// Rebalance signal (hub-and-spoke only): the hub→spoke moves this run
// recommends, one card per spoke. The whole card is the deep link into
// Transfer Planning.
import { SnapshotRebalanceCard } from "./types";
import { EM_DASH, un, usd, useSnapshotTokens } from "./primitives";
import { useGuardedNavigation } from "../../hooks/use_guarded_navigation";

export const RebalanceSignal = ({
  cards,
  transferPlanningPath,
}: {
  cards: SnapshotRebalanceCard[];
  transferPlanningPath: string;
}) => {
  const t = useSnapshotTokens();
  const { navigateWithGuards } = useGuardedNavigation();
  if (!cards.length) {
    return (
      <span
        title="No hub→spoke recommendations were produced by this run"
        style={{ fontSize: 12, color: t.ink4 }}
      >
        No recommended moves in this run
      </span>
    );
  }
  return (
    <div style={{ display: "flex", gap: 12 }}>
      {cards.map((c) => (
        <div
          key={c.toLocationId}
          title="Open Transfer Planning"
          role="link"
          tabIndex={0}
          style={{
            flex: 1,
            position: "relative",
            padding: "10px 12px",
            background: t.surface3,
            borderRadius: 8,
            border: `1px solid ${t.line}`,
            cursor: "pointer",
          }}
          onClick={() => navigateWithGuards(transferPlanningPath)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              navigateWithGuards(transferPlanningPath);
            }
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = t.ink5;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = t.line;
          }}
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            style={{ position: "absolute", top: 10, right: 10, opacity: 0.4 }}
          >
            <path
              d="M2.5 7.5L7.5 2.5M4 2.5h3.5V6"
              stroke="currentColor"
              strokeWidth="1.3"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div style={{ fontSize: 11, color: t.ink3, marginBottom: 3 }}>
            → {c.toLocationName}
          </div>
          <div style={{ fontSize: 19, fontWeight: 700, letterSpacing: -0.4 }}>
            {c.units == null ? EM_DASH : un(c.units)}
            <span style={{ fontSize: 12, fontWeight: 500, color: t.ink3 }}>
              {" "}
              u
            </span>
          </div>
          <div style={{ fontSize: 11, color: t.ink4 }}>
            {c.skus == null ? EM_DASH : `${c.skus} SKUs`}
            {" · "}
            {c.value == null ? EM_DASH : usd(c.value, 2)}
          </div>
        </div>
      ))}
    </div>
  );
};
